import { FilePlus } from 'lucide-react';
import BannerImageComponent from '../../BannerImage/BannerImage';
import BannerImage from '../../../assets/banners/claims-banner.jpg';
import MedicalImage from '../../../assets/cardImages/medical-claim.jpg';
import PageHeader from '../../Typography/PageHeader/PageHeader';
import CardGrid from '../../Card/CardGrid';
import ClaimForm from './form/form';

interface PageProps {
  children?: React.ReactNode;
}

const ClaimsPage: React.FC<PageProps> = () => {
  return (
    <div className="container mx-auto px-8 md:px-0 mb-32">
      <BannerImageComponent imgSrc={BannerImage} />
      <PageHeader mainHeaderText="Claims" />
      <p className="pb-4">
        If student requires medical care while studying, it is critical that
        they contact Sutton Special Risk before seeking treatment. In a serious
        medical emergency, get student to a hospital immediately and have a
        family member or friend, school administrator call Sutton Special Risk
        on their behalf within 24 hours of admission and before any surgery is
        performed. Medical assistance personnel will guide student through the
        healthcare system, assist in locating an appropriate healthcare
        facility, and support them in managing the entire process.
      </p>
      <p>
        U.S. and Canada{' '}
        <a
          href="tel:1-888-575-1231"
          className="text-inglelewer-purple font-bold"
        >
          1-888-575-1231
        </a>
      </p>
      <p className="pb-4">
        Elsewhere{' '}
        <a href="tel:514-375-8234" className="text-inglelewer-purple font-bold">
          514-375-8234
        </a>{' '}
        Collect
      </p>
      <hr className="w-full mt-4 mb-6" />
      <div className="mb-4">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 pb-4">
          How to submit a claim
        </h2>
        <ol className="list-decimal list-inside text-base pl-4 pb-4">
          <li>Download the claim form.</li>
          <li>Complete the claim form.</li>
          <li>Save the completed claim form on your device.</li>
          <li>
            Fill in the details below and attach the claim form and any relevant
            medical records or bills.
          </li>
          <li>Tick the box &apos;statement on authorization&apos;.</li>
          <li>Hit &apos;Submit Claim&apos; button.</li>
        </ol>
      </div>
      <CardGrid
        numberOfCols={2}
        cardData={[
          {
            header: 'Medical Claim Form',
            description:
              'Claim form for medical expenses: Document used to request reimbursement for healthcare services covered by an insurance policy. Click to Download.',
            href: '/pdfs/inglelewer_international_student_medical_claim_form_final_v2.pdf',
            cardImage: MedicalImage,
            isHrefExternal: true,
            icon: (
              <FilePlus
                className="p-3.5"
                stroke="#fff"
                strokeWidth={1}
                size={64}
              />
            ),
          },
        ]}
      />
      <div className="mt-10">
        <h2 className="text-lg font-bold mb-4">
          In order to submit a claim, please enter in the applicant's
          information below:
        </h2>
      </div>
      <ClaimForm />
    </div>
  );
};

export default ClaimsPage;
